import { store } from '../../store'
import { http, httpgst } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  get_areas ({ commit, dispatch }, payload) {
    let url = 'api/areas'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('areasGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  post_areas ({ commit, dispatch }, payload) {
    let url = 'api/areas'
    let params = {
      'name': payload.event.name,
      'company_id': payload.event.company_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.post(url, params, {})
      .then(
        response => {
          commit('areasPost', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  put_areas ({ commit, dispatch }, payload) {
    let url = 'api/areas/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name,
      'company_id': payload.event.item.company_id
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.put(url, params, {})
      .then(
        response => {
          commit('areasPut', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  delete_areas ({ commit, dispatch }, payload) {
    let url = 'api/areas/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('areasDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getCompanies ({ commit, dispatch }, payload) {
    let url = 'api/company'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('companiesGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  userLogin ({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('logged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getByCompany ({ commit, dispatch }, payload) {
    let url = `api/areas-company/${payload.event.company_id}`
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('areasGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getAreasCompany ({ commit, dispatch }, payload) {
    let url = '/api/areas-company/' + store.state.userLogged.company[0].id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('areasGet', {event: payload.event, response: response})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the users endpoint
  areasGet (state, payload) {
    payload.event.context.areas = payload.response.data.data
    payload.event.context.loadingItems = false
  },
  // Add the data from the new user to the users list
  areasPost (state, payload) {
    let area = payload.response.data.data
    area.name = area.name
    area.company_id = area.company_id
    let areas = payload.event.context.areas
    areas.push(area)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.loading = false
    // payload.event.context.refresh()
  },
  // Updates the data displayed for the modified user
  areasPut (state, payload) {
    let area = payload.response.data.data
    area.name = area.name
    area.company_id = area.company_id
    let areas = payload.event.context.areas
    areas.splice(payload.event.index, 1, area)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
    payload.event.context.loading = false
    // payload.event.context.refresh()
  },
  // Removes the data of the deleted user from the users list
  areasDelete (state, payload) {
    let areas = payload.event.context.areas
    areas.splice(payload.event.index, 1)
    // payload.event.context.users = users
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDelete()
    payload.event.context.loading = false
    // payload.event.context.refresh()
  },
  // Shows a error message
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    // payload.event.context.refresh()
    payload.event.context.loadingItems = false
  },
  companiesGet (state, payload) {
    let companies = payload.response.data.data
    payload.event.context.companies = companies
  },
  logged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/areas.js